import { Component, DoCheck, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
declare var Materialize: any;
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: []
})
export class AppComponent implements OnInit {
  

  constructor(
    private _route: ActivatedRoute,
    private _router: Router
  ) { 
    
  }
    ngOnInit() {
       $('.collapsible').collapsible();
     /* $('.button-collapse').sideNav({
        menuWidth: 300, // Default is 300
        edge: 'left', // Choose the horizontal origin
        closeOnClick: false, // Closes side-nav on <a> clicks, useful for Angular/Meteor
        draggable: true // Choose whether you can drag to open on touch screens
      }
    );
    */
    
  }

  Cerrar() {
    $('.button-collapse').sideNav('hide');
  }

  ngDoCheck() {
   // console.log('Método DoCheck lanzado');
  }

  ngOnDestroy(){
//    console.log('Se va a eliminar el componente');
    localStorage.removeItem('tkn');
    localStorage.removeItem('ide');
    localStorage.clear();
}



  esconder() {
    $('.button-collapse').sideNav('hide');
  }
  Sector(i){
    if( i === 1 ){
      localStorage.setItem('s', 'AGRICOLA');
    } else if( i === 2 ){
      localStorage.setItem('s', 'PECUARIO');
    }else if( i === 3 ){
      localStorage.setItem('s', 'FORESTAL');
    }
  }
}



// WEBPACK FOOTER //
// F:/node/angular/complejidadesFrontend/src/app/app.component.ts